import { useRecorderTokenNewMutation } from '@carboncopyco/data';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { Loader } from '@carboncopyco/ui';
import { useEffect, useState } from 'react';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { getRecordingTokenDataKey } from '../../shared/interceptor-state-keys';
import InnerTabsContainer from '../components/InnerTabs/InnerTabsContainer';
import InnerViewArea from '../components/InnerViewArea';
import { debuggerInterceptorState } from '../shared/utils';
import { useTabs, useUser } from '../store/context';
import { ResponsiveModeContextProvider } from '../store/context/ResponsiveModeContext';
import { NewCloneScreen } from './NewCloneScreen';
import { StartRecordingScreen } from './StartRecordingScreen';

interface NewCloneProps {
  tab: IGlobalTab;
  onUrlSelect: (url: string) => void;
}

const CloningRoute = ({ tab, onUrlSelect }: NewCloneProps) => {
  const [isCloningMode, setIsCloningMode] = useState(false);
  const { setActiveRecordingData } = useTabs();
  const [recorderTokenNew, { isLoading }] = useRecorderTokenNewMutation();
  const { activeOrganization } = useUser();

  const handleUrlSelect = async (url: string) => {
    const data = await recorderTokenNew({
      organizationId: `${activeOrganization?.id}`,
      firstUrl: encodeURIComponent(url),
    }).unwrap();
    debuggerInterceptorState.setItem(getRecordingTokenDataKey(tab.id), [data]);
    setActiveRecordingData(data);
    onUrlSelect(url);
    setIsCloningMode(true);
  };

  useEffect(() => {
    if (
      tab.payload?.externalCloneSession?.externalSessionId &&
      tab.payload?.externalCloneSession?.firstUrl
    ) {
      handleUrlSelect(tab.payload?.externalCloneSession.firstUrl);
    }
  }, []);

  if (
    tab.payload?.externalCloneSession?.externalSessionId &&
    tab.payload?.externalCloneSession?.firstUrl &&
    isLoading
  ) {
    return <Loader show />;
  }

  return isCloningMode || tab.innerTabs?.length ? (
    <ResponsiveModeContextProvider>
      <div className=" flex flex-col flex-grow flex-shrink-0 basis-auto">
        <StartRecordingScreen globalTab={tab} />
        <InnerTabsContainer globalTab={tab} />
        <InnerViewArea tab={tab} />
      </div>
    </ResponsiveModeContextProvider>
  ) : (
    <NewCloneScreen onNewClone={handleUrlSelect} />
  );
};

const CloningScreen = ({ tab, onUrlSelect }: NewCloneProps) => (
  <MemoryRouter>
    <Routes>
      <Route
        path="/*"
        element={
          <CloningRoute
            tab={tab}
            onUrlSelect={onUrlSelect}
          />
        }
      />
    </Routes>
  </MemoryRouter>
);

export default CloningScreen;
